<template>
  <el-form
    class="search-form"
    :inline="true"
    :model="form"
    label-width="110px"
  >
    <el-row>
      <el-col :span="6">
        <el-form-item label="货主">
          <el-input
            v-model="form.customerKeyword"
            placeholder="请输入货主名称或编码"
            clearable
            @keyup.enter.native="fetchData"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item class="form-item-prepend" label="租户">
          <template #label>
            <el-select
              v-model="select"
              class="prepend-select"
              placeholder="请选择"
            >
              <el-option label="租户名称" value="tenantNameLike" />
              <el-option label="租户编码" value="tenantIdLike" />
            </el-select>
          </template>
          <el-select
            v-model="form.ownerTenantId"
            filterable
            remote
            clearable
            reserve-keyword
            class="temant-select"
            placeholder="请输入"
            :remote-method="tenantRemote"
            :loading="loading.tenantRemote"
            @change="fetchData"
          >
            <el-option
              v-for="item in tenantOptions"
              :key="item.tenantId"
              :label="item.tenantName"
              :value="item.tenantId"
            >
              <span>{{ item.tenantName }}({{ item.tenantId }})</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="状态">
          <el-select
            v-model="form.statuses"
            placeholder="请选择货主状态"
            clearable
          >
            <el-option
              v-for="(option,index) in statusEnum"
              :key="index"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" class="form-btns">
        <el-button
          class="form-btn"
          type="primary"
          @click.native.prevent="fetchData"
        >
          查询
        </el-button>
        <el-button
          class="form-btn"
          @click.native.prevent="resetData()"
        >
          重置
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import loadingMixin from '@thales/loading';
import { processingSelectData } from '@/utils/index';
import { getTenantList } from '../../api';
import { IS_REPLENISH } from '../const';

export default {
  name: 'ListFilter',
  mixins: [loadingMixin],
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      select: 'tenantNameLike',
      loading: {
        tenantRemote: false,
      },
      customerOptions: [],
      tenantOptions: [],
      statusEnum: [
        {
          value: ['TO_CREATE', 'WAIT_PASS', 'ALREADY_PASS', 'REMOVE_BIND', 'WAIT_DEAL'],
          label: '启用',
        },
        {
          value: ['DELETE', 'WEED_OUT'],
          label: '禁用',
        },
      ],
    };
  },
  computed: {
    isReplenishOptions() {
      return processingSelectData(IS_REPLENISH);
    },
  },
  methods: {
    fetchData() {
      this.$emit('fetchData', 1);
    },
    resetData() {
      this.select = 'tenantNameLike';
      this.customerOptions = [];
      this.tenantOptions = [];
      this.$emit('resetData');
    },
    async tenantRemote(query) {
      if (query) {
        const res = await getTenantList({ [this.select]: query });
        this.tenantOptions = res || [];
      } else {
        this.tenantOptions = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-btns {
  text-align: right;
}
.search-form ::v-deep {
  .form-item-prepend {
    .el-form-item__label {
      padding-right: 0;
    }
    .prepend-select {
      .el-input__inner {
        background-color: #f5f7fa;
        padding: 10px;
        width: 90px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
    }
    .temant-select {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  .el-col {
    margin: 12px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
